export const ru = {
  common: {
    showPassword: 'Показать пароль',
    hidePassword: 'Скрыть пароль',
    currency: 'сум',
    loading: 'Загрузка…',
    retry: 'Повторить',
    save: 'Сохранить изменения',
    cancel: 'Отмена',
    confirm: 'Подтвердить',
    confirmDefault: 'Вы уверены?',
    close: 'Закрыть',
    delete: 'Удалить',
    search: 'Поиск',
    all: 'Все',
    export: 'Экспорт',
    somethingWrong: 'Что-то пошло не так',
    notFound: 'Страница не найдена',
    noAccess: 'У вас нет доступа к этому разделу',
    back: 'Назад',
    prev: 'Предыдущая страница',
    next: 'Следующая страница',
    comingSoon: 'Раздел в разработке',
    comingSoonSubtitle: 'Скоро здесь появится этот раздел',
  },
  units: {
    piece: 'шт',
    kilogram: 'кг',
    meter: 'м',
    bag: 'меш',
    ton: 'т',
    sheet: 'лист',
    bucket: 'вед',
    roll: 'рул',
    box: 'кор',
    pack: 'уп',
    liter: 'л',
  },
  brand: {
    name: 'Buildix',
    footer: '© 2026 Buildix · Strotech',
  },
  sync: {
    unpaired: 'Компьютер магазина не подключён к облаку — данные здесь не обновляются.',
    unpairedShop: 'Этот компьютер не связан с облаком — продажи работают, но владелец не видит их удалённо.',
    staleShop: 'В облако не отправлялись данные уже {{age}} — владелец удалённо видит старые цифры.',
    pushBroken: 'Данные не уходят в облако. Продажи работают, но владелец удалённо видит старые цифры — обратитесь в поддержку.',
    pushBrokenCloud: 'Магазин на связи, но данные не приходят — цифры здесь устарели. Обратитесь в поддержку.',
    stale: 'Данные обновлены {{age}} назад — магазин не на связи.',
    ageUnknown: 'давно',
    ageMinutes: '{{count}} мин',
    ageHours: '{{count}} ч',
    ageDays: '{{count}} дн',
  },
  nav: {
    sections: {
      operations: 'Операции',
      clients: 'Клиенты',
      supply: 'Снабжение',
      management: 'Управление',
    },
    dashboard: 'Панель',
    sales: 'Продажи',
    cash: 'Касса',
    warehouse: 'Склад',
    products: 'Товары и цены',
    categories: 'Категории',
    returns: 'Возвраты',
    debts: 'Долги',
    customers: 'Клиенты',
    purchases: 'Закуп',
    suppliers: 'Поставщики',
    shifts: 'Смены',
    reports: 'Отчёты',
    employees: 'Сотрудники',
    audit: 'Аудит',
    notifications: 'Уведомления',
    settings: 'Настройки',
    account: 'Мой аккаунт',
    logout: 'Выйти',
    menu: 'Меню',
    devices: 'Оборудование',
  },
  devices: {
    title: 'Оборудование',
    subtitle: 'Проверка подключения принтера и сканера',
    printer: {
      connected: 'Подключённые принтеры',
      detect: 'Найти принтер',
      usbFound: 'подключён',
      usbHint: 'Браузер сам не видит принтеры. Нажмите «Найти принтер» и выберите ваш USB-принтер в открывшемся списке.',
      usbUnsupported: 'Этот браузер не показывает USB-устройства (нужен Chrome или Edge). Тестовая этикетка всё равно работает.',
      usbNone: 'Подключённый USB-принтер не найден или не выбран.',
      lastCheck: 'Последняя проверка: {{date}} {{time}}, {{size}} мм —',
      lastOk: 'работал',
      lastFailed: 'не работал',
      goToLabels: 'Печатать этикетки товаров',
      title: 'Принтер этикеток',
      subtitle: 'Браузер не видит список принтеров системы — поэтому самая надёжная проверка это печать настоящей тестовой этикетки.',
      size: 'Размер этикетки',
      test: 'Напечатать тестовую этикетку',
      askResult: 'Этикетка вышла правильно?',
      yes: 'Да',
      no: 'Нет',
      ok: 'Принтер подключён и работает.',
      popupBlocked: 'Браузер заблокировал новое окно — окно печати не открылось. Разрешите всплывающие окна для buildix.uz или скачайте файл.',
      download: 'Скачать PDF',
      troubleTitle: 'Этикетка не вышла — проверьте:',
      trouble1: 'Включён ли принтер и подключён ли кабель USB/сеть',
      trouble2: 'Выбран ли в окне печати именно принтер этикеток (а не A4)',
      trouble3: 'Совпадает ли размер бумаги в настройках принтера с размером этикетки',
      trouble4: 'Не закончился ли рулон и выполнена ли калибровка',
    },
    scanner: {
      title: 'Сканер штрих-кодов (пистолет или стационарный)',
      subtitle: 'Сканер подключается как клавиатура, поэтому его нельзя найти в списке устройств — но его точно выдаёт скорость ввода.',
      placeholder: 'Отсканируйте любой штрих-код в это поле…',
      detected: 'Сканер обнаружен — скорость намного выше человеческой.',
      typed: 'Введено вручную. Если сканер подключён, отсканируйте код заново.',
      tooShort: 'Слишком коротко — для оценки нужно минимум 6 символов.',
      noEnter: 'Сканер не отправляет Enter в конце. Включите это в его настройках, иначе код не добавится в чек сам.',
      code: 'Код',
      chars: 'Символов',
      speed: 'Средний интервал',
      ms: 'мс',
      checkInBase: 'Проверить в базе',
      found: 'Найдено: {{name}}',
      notFound: 'Этого кода нет в базе',
      hint: 'Проверка ничего не сохраняет. Если код не найден — сканер работает, просто этот код не привязан к товару.',
    },
  },
  notifications: {
    subtitle: 'Непрочитанных: {{count}}',
    empty: 'Всё в порядке — уведомлений нет',
    liveHint: 'Складские и долговые оповещения обновляются автоматически. События смен и поставок приходят в момент, когда происходят.',
    markAll: 'Отметить все прочитанными',
    viewAll: 'Показать все',
    today: 'Сегодня',
    yesterday: 'Вчера',
    cat: {
      warehouse: 'Склад',
      debt: 'Долги',
      shift: 'Смены',
      supply: 'Поставки',
    },
    withdrawRequest: 'Запрос на снятие наличных',
    debtOverdue: 'Долг просрочен',
    debtDueToday: 'Срок оплаты долга — сегодня',
    lowStock: 'Мало на складе',
    outOfStock: 'Товар закончился',
  },
  seller: {
    nav: {
      pos: 'Касса',
      sales: 'Мои продажи',
      products: 'Товары',
      clients: 'Клиенты',
      debts: 'Долги',
      supplies: 'Поставки',
      shifts: 'Смены',
      shiftOpen: 'Смена открыта',
      shiftClosed: 'Смена закрыта',
      openShift: 'Открыть смену',
      hoursShort: 'ч',
      minsShort: 'м',
      account: 'Аккаунт',
      notifications: 'Уведомления',
    },
    products: {
      title: 'Товары',
      subtitle: 'Каталог магазина · цены закупа видны владельцу',
      cols: { location: 'МЕСТО' },
      card: {
        price: 'Цена продажи',
        stock: 'Остаток',
        minStock: 'Мин. остаток',
        sku: 'Артикул',
        barcode: 'Штрих-код',
        location: 'Место на складе',
        supplier: 'Поставщик',
        lastIn: 'Последний приход',
        soldMonth: 'Продано за месяц',
        sell: 'Продать — открыть кассу',
        costHidden: 'Цена закупа и наценка видны только владельцу',
      },
    },
    debts: {
      title: 'Долги клиентов',
      subtitle: 'Приём оплаты по долгу · оплата попадает в кассу текущей смены',
      acceptedToday: 'Принятые сегодня',
      acceptedCols: { time: 'ВРЕМЯ', customer: 'КЛИЕНТ', method: 'СПОСОБ', remaining: 'ОСТАТОК ДОЛГА', amount: 'СУММА' },
    },
    clients: {
      title: 'Клиенты',
      subtitle: 'База клиентов магазина · {{count}} записей',
      add: 'Новый клиент',
      addHint: 'Достаточно имени и телефона — остальное можно заполнить позже.',
      searchPlaceholder: 'Поиск по имени или телефону…',
      empty: 'Клиенты не найдены',
      regular: 'постоянный',
      filters: { all: 'Все', withDebt: 'С долгом', regular: 'Постоянные' },
      purchasesCount: '{{count}} покупок',
      cols: { client: 'КЛИЕНТ', phone: 'ТЕЛЕФОН', monthPurchases: 'ПОКУПОК ЗА МЕСЯЦ', lastPurchase: 'ПОСЛЕДНЯЯ', debt: 'ДОЛГ' },
      form: { name: 'Имя / название', phone: 'Телефон', type: 'Тип клиента' },
    },
    supplies: {
      title: 'Поставки',
      subtitle: 'Создаются администратором · вам доступен просмотр и приёмка',
      readOnly: 'Просмотр — изменение и приёмка настраиваются администратором',
      received: 'принята',
      allTitle: 'Все поставки',
      accept: 'Начать приёмку',
      acceptOnArrival: 'Приёмка станет доступна по прибытии',
      eta: 'прибытие: {{date}}',
      positionsAmounts: '{{count}} позиций · суммы видны владельцу',
      filters: { all: 'Все', awaiting: 'Ожидаются', accepted: 'Принятые' },
      cols: { positions: 'ПОЗИЦИЙ' },
      state: { accepted: 'принята', awaiting: 'ожидает приёмки', inTransit: 'в пути', delayed: 'задерживается' },
    },
    notifications: {
      subtitle: 'Активных уведомлений: {{count}}',
      unread: 'Непрочитанные',
      empty: 'Всё в порядке — уведомлений нет',
      liveHint: 'Список отражает текущее состояние: запись исчезает, как только вопрос решён.',
      debtOverdue: 'Долг просрочен',
      debtDueToday: 'Срок оплаты долга — сегодня',
      lowStock: 'Мало на складе',
      outOfStock: 'Товар закончился',
    },
    pos: {
      allProducts: 'Все товары',
      outOfStock: 'нет',
      priceOnRequest: 'Цену уточните',
      receipt: 'Чек',
      clear: 'Очистить',
      discard: 'Удалить чек',
      discardConfirm: 'Удалить незавершённый чек? Позиции вернутся на склад.',
      held: 'Отложенные чеки',
      park: 'Отложить',
      leaveTitle: 'Продажа не завершена',
      leaveMessage:
        'Отложить чек? Он сохранится в списке «Отложенные» — вернётесь к нему в любой момент.',
      stay: 'Остаться на кассе',
      positions: 'Позиций',
      checkoutTitle: 'Оплата',
      toPay: 'К оплате',
      received: 'Получено от клиента',
      noChange: 'Без сдачи',
      change: 'Сдача',
      short: 'Не хватает',
      confirm: 'Подтвердить продажу',
      cardHint: 'Проведите оплату по терминалу и подтвердите после успешной транзакции.',
      debtNeedsCustomer: 'Для продажи в долг выберите клиента из базы',
      paidNow: 'Оплачено сейчас',
      debtRest: 'В долг (остаток)',
      doneTitle: 'Продажа оформлена',
      print: 'Печать чека',
      newSale: 'Новая продажа',
      thanks: 'Спасибо за покупку!',
      shift: 'Смена',
      qty: 'Количество',
      qtyHint: 'Введите количество — можно дробное (12; 3,5; 0,25)',
      editPrice: 'Изменить цену',
      openShift: 'Открыть смену',
      loadMore: 'Показать ещё',
      shownOf: '{{shown}} из {{total}} товаров',
      refineSearch: 'Слишком много результатов — уточните поиск',
      backToSearch: 'Назад к поиску',
      external: {
        button: 'Нет в каталоге',
        title: 'Товар вне каталога',
        subtitle: 'Не влияет на складской остаток — добавляется только в этот чек',
        name: 'Название товара / услуги',
        price: 'Цена продажи',
        cost: 'Закупочная цена (необязательно)',
        costHint: 'Если оставить пустым, в отчёте о прибыли эта позиция пройдёт как чистая прибыль.',
        costTooHigh: 'Закупочная цена должна быть меньше цены продажи.',
        add: 'Добавить в чек',
      },
      askPrice: {
        title: 'Введите цену',
        price: 'Цена продажи',
        add: 'Добавить в чек',
        hint: 'Цена этого товара скрыта от продавца — уточните её у владельца и введите.',
      },
    },
    shifts: {
      range: { week: 'Неделя', month: 'Месяц', all: 'Всё время' },
      total: 'Итого за период',
    },
    sales: {
      returnsStat: 'Возвратов',
      returnsSum: '· {{value}} сум',
      returnOf: 'возврат по чеку №{{number}}',
      returnHint: 'Возврат оформляется через карточку чека · история прошлых смен доступна в «Мои смены»',
    },
  },
  auth: {
    title: 'Вход в систему',
    subtitle: 'Введите данные, выданные владельцем или администратором магазина.',
    usernameLabel: 'Логин',
    usernamePlaceholder: 'Введите логин',
    passwordLabel: 'Пароль',
    passwordPlaceholder: '••••••••',
    forgotPassword: 'Забыли пароль?',
    submit: 'Войти',
    submitting: 'Вход…',
    contactAdmin: 'СВЯЗЬ С АДМИНИСТРАТОРОМ',
    errors: {
      invalidCredentials: 'Неверный логин или пароль',
      generic: 'Не удалось войти. Попробуйте ещё раз.',
      consoleNotConfigured: 'Консоль не настроена — обратитесь к администратору сервера.',
      marketMissing: 'Магазин не найден в этой копии программы. Обратитесь в поддержку.',
      tooManyAttempts: 'Слишком много попыток. Попробуйте позже.',
    },
  },
  subscription: {
    expiredTitle: 'Подписка истекла',
    expiredDesc: 'Срок действия подписки магазина закончился. Свяжитесь с администратором для продления.',
    blockedTitle: 'Магазин заблокирован',
    blockedDesc: 'Доступ к магазину временно приостановлен. Свяжитесь с администратором.',
  },
  categories: {
    title: 'Категории',
    subtitle: 'Направления и продажи по ним',
    add: 'Добавить',
    edit: 'Изменить',
    newPlaceholder: 'Название новой категории…',
    empty: 'Категорий нет. Добавьте первую сверху.',
    uncategorized: 'Без категории',
    deleteTitle: 'Удалить категорию',
    deleteHint: '«{{name}}» будет удалена. {{count}} товаров НЕ пропадут — они останутся без категории.',
    profitNote: 'Прибыль за период: {{value}}',
    stats: { count: 'Категорий', products: 'Товаров', sales: 'Продажи' },
    cols: { name: 'КАТЕГОРИЯ', products: 'ТОВАРОВ', sales: 'ПРОДАЖИ', share: 'ДОЛЯ' },
    addPlaceholder: 'Название категории…',
    deleteConfirm: 'Удалить категорию «{{name}}»?',
  },
  warehouse: {
    title: 'Склад',
    subtitle: '{{count}} позиций · стоимость остатков {{value}} сум',
    subtitleShort: '{{count}} позиций · мало: {{low}} · нет в наличии: {{out}}',
    addProduct: 'Добавить товар',
    newPurchase: 'Оформить закуп',
    stocktake: 'Инвентаризация',
    searchPlaceholder: 'Поиск по названию, артикулу или штрих-коду…',
    onlyLow: 'Только заканчивающиеся',
    allCategories: 'Все',
    showing: 'Показано {{shown}} из {{total}} позиций',
    empty: 'Товары не найдены',
    movementHint: 'Мин. остаток меняется прямо в таблице. Нажмите на строку — движение товара и корректировка.',
    filter: { all: 'Все', ok: 'В норме', low: 'Мало', out: 'Нет' },
    movement: {
      title: 'Движение товара',
      empty: 'Движений пока нет',
      correctionTitle: 'Корректировка (инвентаризация)',
      correctionHint: 'Разница записывается в движение как корректировка и попадёт в журнал',
      actualQty: 'Фактический остаток',
      apply: 'Применить',
      type: {
        initialStock: 'Начальный остаток',
        purchase: 'Приход',
        sale: 'Продажа',
        saleReversal: 'Возврат продажи',
        correction: 'Корректировка',
      },
    },
    stats: {
      positions: 'Всего позиций',
      value: 'Стоимость остатков',
      low: 'Мало на складе',
      out: 'Закончились',
    },
    cols: {
      product: 'ТОВАР',
      sku: 'АРТИКУЛ',
      category: 'КАТЕГОРИЯ',
      stock: 'ОСТАТОК',
      minStock: 'МИН. ОСТАТОК',
      cost: 'ЦЕНА ЗАКУПА',
      price: 'ЦЕНА ПРОДАЖИ',
      status: 'СТАТУС',
      lastReceipt: 'ПОСЛ. ПРИХОД',
    },
    status: {
      inStock: 'В наличии',
      low: 'Мало',
      out: 'Нет',
    },
    form: {
      addTitle: 'Новый товар',
      editTitle: 'Редактировать товар',
      name: 'Название',
      sku: 'Артикул',
      barcode: 'Штрих-код',
      barcodeHint: 'Считайте сканером, создайте кодом системы или впишите свой номер («1», «15»).',
      barcodeShop: 'Код магазина — на этикетке печатается как есть.',
      barcodePlaceholder: 'Отсканируйте или создайте',
      barcodeGenerate: 'Создать',
      barcodeRegenerate: 'Обновить',
      barcodeReplaceConfirm:
        'Заменить код? Этикетки, напечатанные со старым кодом, перестанут работать.',
      barcodeInternal: 'Код магазина — этикетку печатаем сами.',
      barcodeFactory: 'Заводской код — этикетка уже есть на товаре.',
      category: 'Категория',
      unit: 'Ед. изм.',
      salePrice: 'Цена продажи',
      minSalePrice: 'Мин. цена продажи',
      costPrice: 'Цена закупа',
      quantity: 'Остаток',
      minThreshold: 'Мин. остаток',
      hidePrice: 'Скрывать цену от продавцов',
      description: 'Описание',
      descriptionHint: 'Видно продавцу в карточке товара',
      noCategory: 'Без категории',
      delete: 'Удалить',
      deleteConfirm: 'Удалить этот товар?',
      belowCost: 'Цена продажи ниже закупочной',
    },
    stocktakeModal: {
      title: 'Инвентаризация',
      subtitle: 'Введите фактические остатки — расхождения будут зафиксированы',
      searchPlaceholder: 'Поиск товара…',
      system: 'Система',
      counted: 'Факт',
      variance: 'Расхождение',
      submit: 'Провести инвентаризацию',
      resultTitle: 'Инвентаризация завершена',
      adjusted: 'Скорректировано позиций: {{count}}',
      noChanges: 'Расхождений не найдено',
      done: 'Готово',
    },
  },
  products: {
    title: 'Товары и цены',
    subtitle: 'Цена продажи меняется прямо в таблице',
    catalogCount: '{{count}} товаров · скрыто: {{hidden}}',
    margin: 'МАРЖА',
    hidden: 'Скрыт',
    hide: 'Скрыть',
    show: 'Показать',
    hiddenNote: 'Скрытый товар не виден продавцам в кассе, но остаётся в отчётах и истории. Цена закупа обновляется автоматически из последнего закупа.',
  },
  cash: {
    title: 'Касса · наличные',
    subtitle: 'все движения наличных за день',
    shiftOpen: 'смена №{{n}} открыта',
    openingWas: 'на открытии было {{value}}',
    balance: 'Сейчас в кассе',
    incomeToday: 'Приход за день',
    expenseToday: 'Расход за день',
    opsCount: '{{count}} операций',
    empty: 'Движений за день нет',
    hint: 'Продажи и оплаты долга попадают сюда автоматически. Вручную добавляются расход, инкассация в банк и внесение размена. Остаток кассы сверяется при закрытии смены.',
    filter: { all: 'Все', income: 'Приход', expense: 'Расход' },
    cols: { time: 'ВРЕМЯ', type: 'ТИП', description: 'ОПИСАНИЕ', who: 'КТО', amount: 'СУММА' },
    type: {
      opening: 'Открытие',
      sale: 'Продажа',
      debtPayment: 'Оплата долга',
      deposit: 'Внесение',
      expense: 'Расход',
      collection: 'Инкассация',
      externalPurchase: 'Чужой товар',
    },
    desc: { receipt: 'Чек Ч-{{n}}' },
    category: {
      household: 'Хозяйственные',
      delivery: 'Доставка',
      advance: 'Аванс сотруднику',
      other: 'Прочее',
    },
    newOp: {
      button: 'Новая операция',
      title: 'Новая операция',
      category: 'Категория расхода',
      amount: 'Сумма',
      comment: 'Комментарий',
      commentHint: 'Например: вода, пакеты',
      available: 'Доступно в кассе: {{value}} сум',
      overdraft: 'Сумма больше остатка в кассе',
      confirm: 'Провести',
    },
  },
  returns: {
    title: 'Возвраты',
    subtitle: 'за месяц: {{count}} возвратов на {{sum}} сум · {{pct}}% от выручки',
    create: 'Оформить возврат',
    searchPlaceholder: 'Номер возврата, чека или товар…',
    empty: 'Возвратов пока нет',
    hint: 'При возврате товар автоматически встаёт обратно на остатки склада, сумма вычитается из выручки, запись попадает в журнал.',
    cols: { return: 'ВОЗВРАТ', receipt: 'ЧЕК', items: 'ТОВАРЫ', reason: 'ПРИЧИНА', money: 'ДЕНЬГИ', sum: 'СУММА' },
    reason: { defect: 'Брак', notFit: 'Не подошёл', sellerError: 'Ошибка продавца', other: 'Другое' },
    refund: { cash: 'Наличные', card: 'На карту', transfer: 'Перечисление' },
    findReceipt: 'Найдите чек',
    findPlaceholder: 'Номер чека…',
    changeReceipt: 'Другой чек',
    sold: 'продано: {{qty}}',
    refundMethod: 'Вернуть деньги',
    refundMoney: 'К возврату',
  },
  sales: {
    title: 'Продажи',
    newSale: 'Новая продажа',
    searchPlaceholder: 'Поиск по чеку, товару, клиенту…',
    showing: 'Показано {{shown}} из {{total}}',
    empty: 'Продажи не найдены',
    walkIn: 'Розничный',
    allSellers: 'Все продавцы',
    stats: {
      sum: 'Сумма продаж',
      checks: 'Чеков',
      avg: 'Средний чек',
      debt: 'В долг',
      today: 'за сегодня',
    },
    period: { shift: 'Смена', today: 'Сегодня', yesterday: 'Вчера', all: 'Все', week: 'Неделя', month: 'Месяц' },
    payment: {
      all: 'Все',
      cash: 'Наличные',
      card: 'Карта',
      debt: 'В долг',
      // PaymentType.Terminal — чек детали печатает тип платежа как есть, и без
      // этого ключа в истории оплат показывался сырой "terminal".
      terminal: 'Терминал',
      transfer: 'Перевод',
      click: 'Click',
      mixed: 'Смешанно',
      credit: 'Аванс',
      returned: 'Возврат',
      returns: 'Возвраты',
    },
    cols: {
      number: 'ЧЕК №',
      time: 'ВРЕМЯ',
      seller: 'ПРОДАВЕЦ',
      items: 'ТОВАРЫ',
      customer: 'КЛИЕНТ',
      pay: 'ОПЛАТА',
      sum: 'СУММА',
    },
    detail: {
      title: 'Чек',
      customer: 'Клиент',
      status: 'Статус',
      qty: 'КОЛ-ВО',
      price: 'ЦЕНА',
      subtotal: 'Сумма без скидки',
      paid: 'Оплачено',
      remaining: 'Остаток',
      payments: 'Оплаты',
      noPayments: 'Оплат нет',
      noItems: 'Позиций нет',
      invoice: 'Скачать счёт',
      cancel: 'Отменить чек',
      cancelConfirm: 'Отменить чек №{{number}}? Товары вернутся на склад, наличные — из кассы.',
      return: 'Вернуть товар',
      returnConfirm: 'Подтвердить возврат',
    },
    status: {
      draft: 'Черновик',
      paid: 'Оплачен',
      debt: 'В долг',
      partial: 'Частично',
      // SaleStatus.Closed — долг погашен полностью. Ключа не было, и деталь
      // чека показывала сырое "Closed".
      closed: 'Долг погашен',
      cancelled: 'Отменён',
      returned: 'Возврат',
    },
  },
  debts: {
    title: 'Долги',
    subtitle: '{{count}} клиентов · общий долг {{value}} сум',
    subtitleChecks: '{{debts}} долгов у {{clients}} клиентов · всего: {{value}} сум · просрочено: {{overdue}} сум',
    searchPlaceholder: 'Клиент, телефон или номер чека…',
    empty: 'Долгов нет',
    noDue: 'Без срока',
    overdueTag: 'просрочен',
    multi: 'долгов: {{count}}',
    multiTitle: 'У клиента несколько долгов',
    paidOf: 'оплачено {{paid}} из {{total}}',
    checkFor: 'чек на {{total}}',
    perCheckHint: 'Каждый долг — отдельный чек со своим сроком и остатком. Оплата принимается по конкретному чеку, поэтому расчёты не смешиваются.',
    filters: { all: 'Все', overdue: 'Просроченные', today: 'Сегодня', upcoming: 'Предстоящие' },
    stats: {
      total: 'Общий долг',
      overdue: 'Просрочено',
      paidToday: 'Платежи сегодня',
      paidMonth: 'Погашено за месяц',
    },
    cols: { customer: 'КЛИЕНТ', phone: 'ТЕЛЕФОН', debts: 'ДОЛГОВ', due: 'СРОК', sum: 'СУММА', check: 'ЧЕК', items: 'ТОВАРЫ', remaining: 'ОСТАТОК ДОЛГА' },
    type: { individual: 'Физ. лицо', legal: 'Юр. лицо' },
    pay: 'Принять оплату',
    payTitle: 'Принять оплату',
    payAmount: 'Сумма оплаты',
    payMethod: 'Способ оплаты',
    payFull: 'Весь долг',
    moreDebts: 'У клиента ещё {{count}} долгов на {{total}} сум — оплата идёт в счёт самого раннего чека.',
    remaining: 'Остаток долга',
    methods: { cash: 'Наличные', card: 'Карта', transfer: 'Перевод', click: 'Click' },
    dueDate: 'Срок возврата',
    setDueDate: 'Установить срок',
    check: {
      title: '{{name}} · долг по чеку {{check}}',
      sold: 'Продан',
      hasOthers: 'У клиента есть ещё долги: {{count}} — они считаются отдельно',
      cols: { product: 'ТОВАР', qty: 'КОЛ-ВО', price: 'ЦЕНА', sum: 'СУММА' },
      noItems: 'Нет позиций',
      checkTotal: 'Чек на',
      paid: 'Оплачено',
      payThis: 'Принять оплату по этому чеку',
      afterPay: 'После оплаты останется',
      settled: 'чек будет закрыт',
    },
  },
  purchases: {
    title: 'Закуп',
    subtitle: 'Поставки и заказы поставщикам',
    newPurchase: 'Новый закуп',
    empty: 'Закупов нет',
    searchPlaceholder: 'Номер, поставщик или товар…',
    deleteConfirm: 'Удалить закуп №{{number}}? Приход по нему будет отменён.',
    stats: {
      count: 'Закупов за месяц',
      sum: 'Сумма за месяц',
      supplierDebt: 'Долг поставщикам',
      suppliers: 'Поставщиков',
    },
    cols: { number: '№', supplier: 'ПОСТАВЩИК', items: 'ТОВАРЫ', date: 'ДАТА', sum: 'СУММА', status: 'СТАТУС' },
    status: { unpaid: 'Не оплачен', partial: 'Частично', paid: 'Оплачен' },
    reorder: {
      title: 'Рекомендуем заказать',
      positions: '{{count}} позиций',
      empty: 'Всё в достатке',
      perDay: '{{qty}} {{unit}}/день',
      daysLeft: 'осталось {{qty}} {{unit}} · на {{days}} дн.',
      outOfStock: 'Закончился',
      order: 'Заказать',
    },
    topSuppliers: 'Топ поставщики',
    manageSuppliers: 'Управление',
    noSupplier: 'Без поставщика',
    itemsCount: '{{count}} тов.',
    newModal: {
      title: 'Новый приход',
      subtitle: 'Поступление товара на склад',
      invoice: 'Накладная №',
      addItems: 'Добавить товары',
      quickAdd: 'Заканчивается — быстро добавить',
      empty: 'Найдите товар и добавьте его в приход',
      paidNow: 'Оплачено сейчас',
      payFull: 'Вся сумма',
      debtRest: 'Останется долг',
      payMethod: 'Способ оплаты',
      payMethods: { cash: 'Наличные', transfer: 'Перечисление' },
      expectedDate: 'Дата прибытия',
      comment: 'Комментарий (необязательно)',
      submit: 'Оформить приход',
      inTransit: 'Товар ещё в пути',
      inTransitHint: 'Склад не пополнится, пока поставку не примут',
    },
    delivery: { all: 'Все', inTransit: 'В пути', accepted: 'Принят' },
    detail: {
      title: 'Приход',
      paid: 'Оплачено',
      outstanding: 'Остаток долга',
      payTitle: 'Оплатить поставщику',
      pay: 'Оплатить',
      delivery: 'Поставка',
      accept: 'Отметить принятым',
      payFullDebt: 'Весь долг',
      inTransitHint: 'Товар ещё в пути. После приёмки остатки склада пополнятся.',
    },
  },
  suppliers: {
    title: 'Поставщики',
    subtitle: 'Справочник поставщиков и их долги',
    subtitleDebt: '{{count}} поставщика · долг перед поставщиками: {{debt}} сум',
    add: 'Добавить поставщика',
    empty: 'Поставщиков нет',
    searchPlaceholder: 'Поиск поставщика…',
    cols: { name: 'ПОСТАВЩИК', phone: 'ТЕЛЕФОН', debt: 'ДОЛГ', receipts: 'ПРИХОДОВ' },
    debtLabel: 'Долг перед поставщиком',
    noDebt: 'нет долга',
    weOwe: 'мы должны',
    payDebt: 'Погасить долг',
    fifoHint: 'Оплата закрывает долг с самого раннего закупа (FIFO).',
    recentReceipts: 'Последние закупы',
    deleteConfirm: 'Удалить поставщика «{{name}}»?',
    deleteBlocked: 'Нельзя удалить: {{count}} приходов, долг {{debt}} сум.',
    form: {
      addTitle: 'Новый поставщик',
      editTitle: 'Редактировать поставщика',
      name: 'Название',
      phone: 'Телефон',
      contact: 'Контактное лицо',
      deliveryTerm: 'Срок доставки',
      address: 'Адрес',
      comment: 'Комментарий',
    },
  },
  customers: {
    title: 'Клиенты',
    subtitle: 'База клиентов · {{count}} записей',
    add: 'Новый клиент',
    empty: 'Клиенты не найдены',
    searchPlaceholder: 'Поиск по имени или телефону…',
    filters: { all: 'Все', withDebt: 'С долгом', legal: 'Организации' },
    cols: { name: 'КЛИЕНТ', phone: 'ТЕЛЕФОН', debt: 'ДОЛГ', type: 'ТИП', purchases: 'ПОКУПОК', totalBought: 'КУПИЛ ВСЕГО' },
    types: { individual: 'Розничный', legal: 'Юр. лицо' },
    lastBuy: 'последняя покупка: {{date}}',
    noBuys: 'покупок ещё нет',
    deleteConfirm: 'Удалить клиента «{{name}}»?',
    deleteBlocked: 'Нельзя удалить: {{debts}} долгов на {{debt}} сум.',
    form: {
      addTitle: 'Новый клиент',
      editTitle: 'Редактировать клиента',
      name: 'Имя / название',
      phone: 'Телефон',
      type: 'Тип клиента',
      debtLimit: 'Лимит долга',
      noLimit: 'Без лимита',
      initialDebt: 'Начальный долг',
      regular: 'Постоянный клиент',
      regularHint: 'Может брать в долг при включённом ограничении',
      comment: 'Комментарий',
    },
    detail: {
      title: 'Клиент',
      totalDebt: 'Текущий долг',
      debts: 'Долги',
      noDebts: 'Долгов нет',
      recentPurchases: 'Последние покупки',
      noPurchases: 'Покупок пока нет',
      allSales: 'Все продажи клиента',
      acceptDebt: 'Принять оплату долга',
      due: 'до {{date}}',
      status: { open: 'Открыт', closed: 'Закрыт' },
    },
  },
  shifts: {
    title: 'Смены',
    subtitle: 'Кассовые смены и контроль наличных',
    subtitleLive: 'сейчас открыто: {{open}} · за неделю: {{count}} смен · расхождения кассы: {{diff}} сум',
    openShift: 'Открыть смену',
    closeShift: 'Закрыть смену',
    open: 'Открыта',
    closed: 'Закрыта',
    currentShift: 'Текущая смена',
    cashier: 'Кассир',
    noOpenShift: 'Смена закрыта',
    metrics: {
      opening: 'В кассе на начало',
      cashIn: 'Наличными за смену',
      cardIn: 'Картой за смену',
      terminal: 'Терминал',
      click: 'Click',
      withdrawals: 'Снятия',
      expected: 'Должно быть в кассе',
    },
    history: 'История смен',
    cols: { date: 'ДАТА', cashier: 'КАССИР', period: 'ПЕРИОД', checks: 'ЧЕКОВ', revenue: 'ВЫРУЧКА', discrepancy: 'РАСХОЖДЕНИЕ', status: 'СТАТУС' },
    status: { open: 'Открыта', balanced: 'Сошлась', discrepancy: 'Расхождение' },
    empty: 'Смен пока нет',
    tabs: { journal: 'Журнал смен', attendance: 'Посещаемость' },
    filter: { all: 'Все', open: 'Открытые', discrepancy: 'С расхождением' },
    tender: { cash: 'Наличные', card: 'Карта', debt: 'В долг', returns: 'Возвраты' },
    detail: {
      title: 'Смена',
      checks: '{{count}} чеков',
      revenueByTender: 'Выручка по способам оплаты',
      totalRevenue: 'Итого выручка',
      cashRecon: 'Сверка наличных при закрытии',
      externalPayouts: 'Выплачено чужому магазину',
      expectedCash: 'Ожидалось в кассе',
      countedCash: 'Пересчитано продавцом',
      discrepancy: 'Расхождение',
      notClosed: 'Смена ещё открыта — сверка будет доступна после закрытия.',
    },
    attendance: {
      title: 'Посещаемость',
      scheduleHint: 'график: {{from}}–{{to}} · план к этому дню: {{plan}} ч',
      range: { week: 'Неделя', month: 'Месяц' },
      cols: { employee: 'СОТРУДНИК', shifts: 'СМЕН', days: 'ДНЕЙ', hours: 'ЧАСОВ', avg: 'СР. СМЕНА', late: 'ОПОЗДАНИЯ', plan: 'ВЫПОЛНЕНИЕ ПЛАНА' },
      hoursValue: '{{value}} ч',
      noLate: 'нет',
      lateTimes: '{{count}} раз',
      empty: 'Нет данных за период',
    },
    withdraw: {
      action: 'Снятие наличных',
      request: 'Запрос на снятие',
      amount: 'Сумма',
      comment: 'Комментарий (необязательно)',
      submitRequest: 'Отправить запрос',
      submitWithdraw: 'Снять',
      pendingTitle: 'Запросы на снятие',
      noPending: 'Нет ожидающих запросов',
      approve: 'Одобрить',
      reject: 'Отклонить',
      from: 'от {{name}}',
      status: { pending: 'Ожидает', approved: 'Одобрено', rejected: 'Отклонено', notRequired: 'Снятие' },
    },
    close: {
      title: 'Закрытие смены',
      expected: 'Должно быть в кассе',
      counted: 'Фактическая сумма',
      discrepancy: 'Расхождение',
      confirm: 'Закрыть смену',
    },
    forceClose: {
      action: 'Закрыть',
      title: 'Принудительно закрыть смену · {{name}}',
    },
    rules: {
      title: 'Правила смены',
      r1: 'Продажи возможны только при открытой смене',
      r2: 'Снятие наличных — с подтверждением владельца',
      r3: 'При закрытии кассир указывает фактическую сумму',
      r4: 'Расхождение фиксируется и видно владельцу',
    },
  },
  desktop: {
    title: 'Программа магазина',
    subtitle: 'Касса работает и без интернета — устанавливается на компьютер магазина',
    step1: 'Скачайте файл и запустите его на компьютере магазина.',
    step2: 'При первом запуске введите адрес ниже и логин-пароль ВЛАДЕЛЬЦА магазина.',
    step3: 'После этого кассиры входят под своими логинами.',
    urlLabel: 'Адрес для ввода в программе',
    download: 'Скачать (Windows)',
    version: 'версия {{version}}',
    notReady: 'Программа пока недоступна для скачивания. Обратитесь в поддержку.',
  },

  settings: {
    title: 'Настройки',
    subtitle: 'Магазин, касса и параметры системы',
    saved: 'Изменения сохранены',
    language: {
      title: 'Язык интерфейса',
      hint: 'Применяется сразу и сохраняется в вашем аккаунте',
      saveError: 'Не удалось сохранить язык — попробуйте ещё раз',
    },
    store: {
      title: 'Магазин',
      phone: 'Телефон',
      address: 'Адрес',
    },
    cash: {
      title: 'Касса и смены',
      onlyShift: 'Продажи только при открытой смене',
      onlyShiftHint: 'Кассир обязан открыть смену перед первой продажей',
      approval: 'Снятие наличных — с одобрения владельца',
      approvalHint: 'Администратор отправляет запрос, вы подтверждаете',
      debtRegulars: 'Продажа в долг — только постоянным клиентам',
      debtRegularsHint: 'Долг оформляется только на клиента из базы',
      debtLimit: 'Лимит долга на одного клиента',
      debtLimitHint: 'Продажа в долг сверх лимита блокируется',
      discrepancy: 'Допустимое расхождение кассы',
    },
    attendance: {
      title: 'Посещаемость и график',
      hint: 'График работы магазина — по нему считаются часы и опоздания на вкладке «Посещаемость».',
      start: 'Начало дня',
      end: 'Конец дня',
      late: 'Порог опоздания',
    },
    stock: {
      belowCost: 'Запрет продажи ниже закупочной цены',
      belowCostHint: 'Кассир не сможет продать в минус',
    },
    receipt: {
      title: 'Чек',
      subtitle: 'Размер ленты и печать',
      width: 'Ширина ленты',
      widthHint: 'Должна совпадать с бумагой в принтере — иначе чек не поместится и печатается по одной букве в строке.',
      mm: 'мм',
      autoPrint: 'Печатать чек автоматически',
      autoPrintHint: 'Сразу после закрытия продажи, без окна печати.',
      header: 'Верхний текст чека',
      footer: 'Нижний текст чека',
    },
    label: {
      title: 'Этикетка',
      subtitle: 'Рулон товарных этикеток',
      width: 'Ширина рулона',
      height: 'Высота этикетки',
      sizeHint: 'Размер одной этикетки в рулоне. Именно он используется при печати.',
      gap: 'Зазор',
      gapHint: 'Промежуток между двумя этикетками. Почти всегда 2 мм.',
      offset: 'Вертикальный сдвиг',
      offsetHint:
        'Макет сдвигается вниз на столько миллиметров. Если рамка тестовой этикетки ушла вверх — измерьте разницу и впишите сюда.',
      calibrate: 'Калибровка',
      test: 'Тестовая этикетка',
      toolsHint:
        'При смене рулона СНАЧАЛА нажмите «Калибровка» — принтер сам измерит длину этикетки (одна-две выйдут пустыми, это нормально). Затем проверьте «Тестовой этикеткой»: если рамка легла ровно по краю — размер верный. Обе кнопки работают со значениями на экране, сохранять не нужно.',
      needDesktop: 'Отправить на принтер этикеток можно только из программы магазина.',
      failed: 'Не удалось отправить на принтер этикеток.',
    },
    notify: {
      title: 'Уведомления',
      subtitle: 'Что присылать владельцу в Telegram',
      daySummary: 'Итог дня при закрытии смены',
      overdue: 'Просроченные долги',
      withdrawals: 'Запросы на снятие наличных',
      telegramHint: 'Telegram подключается в разделе «Аккаунт» — каждый сотрудник сохраняет свой Telegram ID.',
    },
    system: {
      title: 'Система',
      subtitle: 'Язык магазина, безопасность и аудит',
      defaultLanguage: 'Язык магазина по умолчанию',
      defaultLanguageHint: 'Для новых сотрудников; у каждого свой личный язык',
      inactivityLogout: 'Автовыход при неактивности',
      inactivityLogoutHint: '0 — не выходить автоматически',
      minutes: 'мин',
      audit: 'Журнал аудита',
      auditHint: 'Записывать действия сотрудников',
    },
    terminals: {
      title: 'Компьютер, привязанный к облаку',
      subtitle: 'Касса с базой магазина. Только один',
      none: 'Пока ни один компьютер не привязан.',
      pairedAt: 'Привязан',
      lastSeen: 'Последняя связь',
      never: 'связи не было',
      revoked: 'Отключён',
      revoke: 'Отключить',
      confirmTitle: 'Отключить компьютер от облака',
      confirmBody:
        '«{{name}}» будет отключён от облака — это необратимо, потребуется новая привязка. На нём могут оставаться неотправленные продажи: после отключения они не уйдут. Продолжайте, только если со старым компьютером закончили.',
      hint: 'Вторую кассу сюда добавлять не нужно — она подключается к серверной кассе по локальной сети.',
    },
  },
  employees: {
    title: 'Сотрудники',
    subtitle: '{{count}} сотрудников · {{active}} активных сегодня',
    add: 'Добавить сотрудника',
    searchPlaceholder: 'Поиск по имени или логину…',
    empty: 'Сотрудники не найдены',
    online: 'Сейчас в системе',
    lastSeen: 'был {{time}} назад',
    never: 'не заходил',
    block: 'Блокировать',
    unblock: 'Разблокировать',
    blocked: 'Заблокирован',
    active: 'Активен',
    protected: 'Владелец и супер-админ настраиваются отдельно',
    editTitle: 'Редактировать сотрудника',
    deleteTitle: 'Удалить',
    deleteConfirm: 'Удалить сотрудника «{{name}}»?',
    resetPassword: 'Сбросить пароль',
    resetPasswordHint: 'Оставьте пустым, чтобы не менять',
    periodLabel: 'Результаты за:',
    period: { today: 'Сегодня', week: 'Неделя', month: 'Месяц', year: 'Год' },
    stats: { checks: 'Чеков', revenue: 'Выручка', shifts: 'Смен' },
    roles: { all: 'Все', owner: 'Владелец', admin: 'Админ', seller: 'Продавец' },
    form: {
      title: 'Новый сотрудник',
      fullName: 'Имя и фамилия',
      username: 'Логин',
      password: 'Пароль',
      role: 'Роль',
    },
  },
  permissions: {
    title: 'Права доступа',
    customized: 'Настроены вручную',
    roleDefault: 'По умолчанию для роли',
    reset: 'Сбросить к роли',
    profile: 'Профиль доступа',
    preset: { trainee: 'Стажёр', seller: 'Продавец', senior: 'Старший' },
    discountLimit: 'Лимит скидки',
    debtLimit: 'Долг на чек',
    noLimit: 'Без лимита',
    byRole: 'по роли',
    effectNote: 'Изменения вступят в силу при следующем входе сотрудника.',
    savedNote: 'Сохранено · вступит в силу при следующем входе.',
    risk: 'РИСК',
    capabilities: 'Что сможет делать',
    noCapabilities: 'Только базовый доступ',
    cap: {
      disc: 'скидки до {{value}}%',
      discFree: 'скидки без лимита',
      debt: 'долг {{value}}',
      debtFree: 'долг без лимита',
      price: 'меняет цены',
      ret: 'возвраты',
      supply: 'приёмка',
    },
    hint: {
      'sales.edit': 'Менять цену позиции — каждое изменение попадает в журнал',
      'sales.return': 'Оформлять возврат самостоятельно, без кода администратора',
      'sales.delete': 'Удалять проведённые чеки',
      'debts.manage': 'Оформлять чек с долгом клиента и принимать оплату',
      'zakup.accept': 'Подтверждать приход товара на склад',
      'zakup.delete': 'Удалять закупы — приход по ним отменяется',
      'products.delete': 'Удалять товары из каталога',
      'suppliers.delete': 'Удалять поставщиков',
      'customers.delete': 'Удалять клиентов из базы',
      'users.manage': 'Создавать сотрудников и менять их доступы',
      'cashregister.manage': 'Выдавать деньги из кассы (инкассация)',
      'data.costPrice': 'Видеть цену закупа и себестоимость',
      'data.profit': 'Видеть прибыль и маржу',
      'data.auditLog': 'Доступ к журналу действий сотрудников',
    },
    groups: {
      dashboard: 'Панель',
      sales: 'Продажи',
      products: 'Товары',
      categories: 'Категории',
      zakup: 'Закуп',
      suppliers: 'Поставщики',
      customers: 'Клиенты',
      debts: 'Долги',
      cashregister: 'Касса',
      reports: 'Отчёты',
      users: 'Сотрудники',
      notifications: 'Уведомления',
      data: 'Доступ к данным',
    },
    perm: {
      'dashboard.access': 'Видеть панель',
      'notifications.access': 'Видеть уведомления',
      'products.access': 'Видеть товары',
      'products.create': 'Создавать товары',
      'products.edit': 'Редактировать товары',
      'products.delete': 'Удалять товары',
      'products.export': 'Экспорт товаров',
      'products.import': 'Импорт товаров',
      'categories.access': 'Видеть категории',
      'categories.manage': 'Управлять категориями',
      'sales.access': 'Видеть продажи',
      'sales.create': 'Создавать продажи',
      'sales.edit': 'Редактировать продажи',
      'sales.delete': 'Отменять продажи',
      'sales.export': 'Экспорт продаж',
      'sales.invoice': 'Печать счёта',
      'sales.return': 'Оформлять возвраты',
      'customers.access': 'Видеть клиентов',
      'customers.manage': 'Управлять клиентами',
      'customers.delete': 'Удалять клиентов',
      'customers.export': 'Экспорт клиентов',
      'zakup.access': 'Видеть закуп',
      'zakup.create': 'Создавать закуп',
      'zakup.accept': 'Принимать поставки',
      'zakup.delete': 'Удалять закуп',
      'suppliers.access': 'Видеть поставщиков',
      'suppliers.manage': 'Управлять поставщиками',
      'suppliers.delete': 'Удалять поставщиков',
      'cashregister.access': 'Видеть кассу',
      'cashregister.manage': 'Управлять кассой',
      'reports.access': 'Видеть отчёты',
      'reports.export': 'Экспорт отчётов',
      'users.access': 'Видеть сотрудников',
      'users.manage': 'Управлять сотрудниками',
      'users.shift': 'Управлять сменами',
      'debts.access': 'Видеть долги',
      'debts.manage': 'Управлять долгами',
      'debts.dueDate': 'Менять срок долга',
      'data.costPrice': 'Видеть цену закупа',
      'data.profit': 'Видеть прибыль',
      'data.cashBalance': 'Видеть баланс кассы',
      'data.allSalesView': 'Видеть все продажи',
      'data.auditLog': 'Видеть журнал аудита',
    },
  },
  audit: {
    title: 'Журнал аудита',
    subtitle: 'Кто и что делал в системе',
    tabs: { log: 'Журнал', suspicious: 'Подозрительное' },
    allActions: 'Все действия',
    allUsers: 'Все пользователи',
    empty: 'Записей нет',
    cols: { time: 'ВРЕМЯ', action: 'ДЕЙСТВИЕ', user: 'ПОЛЬЗОВАТЕЛЬ', entity: 'ОБЪЕКТ' },
    actions: {
      Create: 'Создание',
      Update: 'Изменение',
      Delete: 'Удаление',
      Cancel: 'Отмена',
      Return: 'Возврат',
      Discount: 'Скидка',
      MarkDebt: 'В долг',
      Payment: 'Оплата',
      Withdraw: 'Снятие',
      Deposit: 'Внесение',
      Open: 'Открытие',
      Close: 'Закрытие',
      Block: 'Блокировка',
      Unblock: 'Разблокировка',
      Activate: 'Активация',
      Deactivate: 'Деактивация',
      PermissionChange: 'Изменение прав',
      PriceOverride: 'Изменение цены',
      StockAdjust: 'Корректировка склада',
      Stocktake: 'Инвентаризация',
      Login: 'Вход',
      LoginFailed: 'Неудачный вход',
      Logout: 'Выход',
      PasswordChange: 'Смена пароля',
    },
    entities: {
      Sale: 'Продажа',
      Product: 'Товар',
      Customer: 'Клиент',
      Supplier: 'Поставщик',
      User: 'Сотрудник',
      Debt: 'Долг',
      Shift: 'Смена',
      CashRegister: 'Касса',
      Market: 'Магазин',
      Auth: 'Авторизация',
    },
    suspicious: {
      clean: 'Всё чисто — подозрительной активности нет',
      failedLogins: 'Множественные неудачные входы',
      bulkDelete: 'Массовое удаление',
      errors: 'Недавние ошибки сервера',
      attempts: '{{count}} попыток',
      deletes: '{{count}} удалений',
    },
  },
  account: {
    title: 'Мой аккаунт',
    subtitle: 'Личные данные и безопасность входа',
    language: {
      title: 'Язык интерфейса',
      subtitle: 'Применяется сразу и сохраняется в вашем аккаунте',
      saveError: 'Не удалось сохранить язык — попробуйте ещё раз',
    },
    profile: 'Профиль',
    fullName: 'Имя и фамилия',
    phone: 'Телефон',
    telegram: 'Telegram',
    telegramSaved: 'Telegram сохранён',
    openBot: 'Открыть бота',
    telegramLink: 'Telegram-бот',
    telegramLinked: 'Привязан',
    telegramUnlink: 'Отвязать',
    telegramLinkAction: 'Привязать',
    telegramLinkHint: 'Напишите боту любое сообщение — он пришлёт 6-значный код. Введите его здесь (действует 10 минут).',
    telegramLinkDone: 'Telegram привязан',
    login: 'Логин',
    loginLocked: 'логин изменить нельзя',
    nameLocked: 'изменение имени — у администратора',
    myResults: { title: 'Мои результаты · {{month}}', revenue: 'Продажи', checks: 'Чеков', avgCheck: 'Средний чек', shifts: 'Смен отработано' },
    password: {
      title: 'Смена пароля',
      hint: 'Минимум 8 символов, буквы и цифры',
      current: 'Текущий пароль',
      new: 'Новый пароль',
      repeat: 'Повторите пароль',
      mismatch: 'Пароли не совпадают',
      change: 'Сменить пароль',
      changed: 'Пароль изменён',
    },
    notify: {
      title: 'Уведомления в Telegram',
      subtitle: 'Что присылать вам в личный Telegram',
      debt: 'Просроченные долги',
      stock: 'Товар закончился',
      shift: 'Закрытие смены',
      noTelegram: 'Привяжите Telegram-бот выше, чтобы получать уведомления.',
    },
    sessions: {
      title: 'Устройства и сессии',
      subtitle: 'Где выполнен вход в ваш аккаунт',
      thisDevice: 'это устройство',
      revoke: 'Завершить',
      revokeOthers: 'Завершить все другие сессии',
      empty: 'Активных сессий нет',
      now: 'сейчас',
    },
    history: {
      clear: 'Очистить',
      title: 'Последние входы',
      subtitle: 'История входов в аккаунт',
      cols: { time: 'ВРЕМЯ', device: 'УСТРОЙСТВО', status: 'СТАТУС' },
      success: 'Успешно',
      failed: 'Неверный пароль',
      empty: 'Нет записей',
    },
  },
  dashboard: {
    title: 'Панель владельца',
    newSale: 'Новая продажа',
    shiftOpenAt: 'Смена открыта · с {{time}}',
    shiftClosed: 'Смена закрыта',
    stats: {
      salesToday: 'Продажи за сегодня',
      profitToday: 'Прибыль за сегодня',
      cashInRegister: 'Наличные в кассе',
      customerDebts: 'Долги клиентов',
      vsYesterday: 'к вчерашнему дню',
      checksCount: '{{count}} чеков',
      margin: 'маржа {{value}}',
      withdrawalsToday: 'снятий сегодня: {{count}} · на {{amount}}',
      noWithdrawals: 'снятий сегодня нет',
      overdueCount: '{{count}} просрочен',
      totalCustomers: 'всего {{count}} клиентов',
      sellersOnShift: 'Продавцы на смене',
      onShiftNow: 'сейчас на кассе: {{count}}',
      noOpenShift: 'нет открытых смен',
      stockSignals: 'Сигналы склада',
      outCount: '{{count}} нет в наличии',
      lowCount: '{{count}} заканчивается',
      stockOk: 'склад в норме',
    },
    chart: {
      title: 'Выручка за неделю',
      total: 'Итого',
    },
    recent: {
      title: 'Последние продажи',
      all: 'Все продажи',
      empty: 'Продаж пока нет',
      openHint: 'Открыть чек — изменить, аннулировать, вернуть',
      cols: { time: 'ВРЕМЯ', seller: 'ПРОДАВЕЦ', items: 'ТОВАРЫ', pay: 'ОПЛАТА', sum: 'СУММА' },
    },
    purchases: {
      title: 'Закупы',
      all: 'Все закупы',
      empty: 'Закупов пока нет',
      inTransit: 'В пути',
      accepted: 'Принят',
      positions: '{{count}} позиций',
      accept: 'Принять',
    },
    sellerAccess: {
      title: 'Доступы продавцов',
      configure: 'Настроить',
      empty: 'Продавцы не добавлены',
      active: 'Активен',
      blocked: 'Заблокирован',
    },
    attention: {
      title: 'Требует внимания',
      open: { shift: 'открыть сверку смены', warehouse: 'открыть склад', debt: 'открыть долги', supply: 'открыть поставку', default: 'открыть' },
    },
    lowStock: {
      title: 'Заканчиваются на складе',
      order: 'Оформить закуп',
      empty: 'Всё в достатке',
    },
    payments: {
      title: 'Ближайшие платежи',
      all: 'Все долги',
      empty: 'Ближайших платежей нет',
      due: 'до {{date}}',
      today: 'сегодня',
      inDays: 'через {{count}} дн.',
      overdueDays: 'просрочен {{count}} дн.',
    },
    shift: {
      title: 'Смена · сегодня',
      cashier: 'Кассир',
      openedAt: 'Открыта',
      checks: 'Чеков',
      avgCheck: 'Средний чек',
      noShift: 'Смена не открыта',
    },
  },
  reports: {
    title: 'Отчёты',
    subtitle: 'Финансовая картина бизнеса',
    download: 'Скачать отчёт',
    period: { week: 'Неделя', month: 'Месяц', quarter: 'Квартал' },
    stats: {
      revenue: 'Выручка',
      profit: 'Прибыль',
      expenses: 'Расходы на закуп',
      avgCheck: 'Средний чек',
      vsPrevPeriod: 'к прошлому периоду',
      margin: 'маржа {{value}}',
      purchCount: '{{count}} закупов',
      checksCount: '{{count}} чеков',
      checksReturns: '{{count}} чеков · возвратов: {{returns}}',
    },
    chart: {
      title: 'Выручка и прибыль по дням',
      revenue: 'Выручка',
      profit: 'Прибыль',
      best: 'лучший',
    },
    categories: {
      title: 'Продажи по категориям',
      empty: 'Нет данных за период',
    },
    payments: {
      title: 'Способы оплаты',
      empty: 'Нет данных за период',
      debtRisk: 'В долг {{value}} — высокая доля. Следите за возвратом долгов.',
    },
    topProducts: {
      title: 'Топ-5 товаров',
      empty: 'Нет продаж за период',
      cols: { product: 'ТОВАР', sold: 'ПРОДАНО', revenue: 'ВЫРУЧКА' },
    },
    staff: {
      title: 'Продавцы',
      empty: 'Нет данных за период',
      cols: { seller: 'ПРОДАВЕЦ', checks: 'ЧЕКОВ', revenue: 'ВЫРУЧКА', share: 'ДОЛЯ' },
      checksAvg: '{{count}} чеков · ср. {{avg}}',
      shareNote: 'Доля от выручки периода',
    },
  },
  labels: {
    popupBlocked: 'Браузер заблокировал окно печати — файл скачан. Проверьте принтер в разделе «Оборудование».',
    printFailed: 'Не удалось открыть окно печати. Проверьте настройки браузера.',
    title: 'Печать этикеток',
    subtitle: '{{count}} товаров',
    print: 'Напечатать {{count}} шт.',
    pcs: 'шт.',
    size: 'Размер',
    mm: 'мм',
    sizeFromSettings: '— рулон из Настроек',
    previewCaption: 'Предпросмотр — так и напечатается ({{w}}×{{h}} мм)',
    previewFailed: 'Не удалось построить предпросмотр',
    willGenerate: 'код будет создан',
    generateNote: 'У {{count}} товаров нет штрих-кода — он будет создан автоматически перед печатью.',
    printerHint:
      'В окне печати выберите принтер этикеток и масштаб «100%». Принтер, настроенный на A4, напечатает этикетку маленькой в углу листа.',
    fromProduct: 'Печать этикетки',
    selected: 'Выбрано: {{count}}',
    selectAll: 'Выбрать всё на странице',
    clearSelection: 'Отменить',
    afterAccept: 'Приёмка завершена. Напечатать этикетки?',
    later: 'Позже',
  },
  pos: {
    title: 'Новая продажа',
    creditApplied: 'Зачтено из аванса клиента',
    back: 'К продажам',
    park: 'Отложить',
    held: 'Отложенные чеки',
    leaveTitle: 'Продажа не завершена',
    leaveMessage:
      'Отложить чек? Он сохранится в списке «Отложенные» — вернётесь к нему в любой момент.',
    stay: 'Остаться на кассе',
    discard: 'Удалить чек',
    discardConfirm: 'Удалить незавершённый чек? Товары вернутся на склад.',
    searchPlaceholder: 'Отсканируйте штрих-код или найдите по названию…',
    scan: {
      notFound: '{{code}} — товар с таким штрих-кодом не найден',
    },
    emptyCart: 'Корзина пуста — найдите товар, чтобы начать продажу',
    cols: {
      product: 'ТОВАР',
      qty: 'КОЛ-ВО',
      price: 'ЦЕНА',
      subtotal: 'СУММА',
    },
    quantity: 'Количество',
    price: 'Цена',
    subtotal: 'Сумма',
    discount: 'Скидка',
    remove: 'Убрать',
    customer: {
      label: 'Клиент',
      walkIn: 'Розничный',
      add: 'Добавить клиента',
      searchPlaceholder: 'Поиск клиента по имени или телефону…',
    },
    total: 'Итого',
    amount: 'Сумма к оплате',
    mix: {
      rest: 'остаток',
      remainder: 'Остаток',
    },
    done: {
      title: 'Продажа оформлена',
      print: 'Распечатать чек',
      finish: 'Завершить',
      receipt: 'Чек',
      shift: 'Смена',
      thanks: 'Спасибо за покупку!',
      printProblem: 'Чек не напечатан:',
      printFailed: 'не удалось связаться с принтером.',
    },
    payment: {
      title: 'Способ оплаты',
      cash: 'Наличные',
      card: 'Карта',
      transfer: 'Перевод',
      click: 'Click',
      debt: 'В долг',
      mixed: 'Микс',
    },
    dueDate: 'Срок возврата',
    checkout: 'Оформить продажу',
    success: 'Продажа оформлена',
  },
  landing: {
    nav: {
      login: 'Войти',
    },
    hero: {
      eyebrow: 'ERP для строительного бизнеса',
      title: 'Наведите порядок в строительном магазине',
      subtitle:
        'Продажи, склад, долги клиентов и отчётность — в одной системе. 6 модулей, 3 роли: владелец, администратор и продавец.',
      bullets: {
        b1: 'Продажа — за 15 секунд',
        b2: 'Остатки — сразу после каждого чека',
        b3: 'Отчёт за день — в Telegram в 21:00',
      },
    },
    modules: {
      eyebrow: 'Что внутри',
      title: 'Шесть модулей — весь магазин',
      sales: {
        title: 'Продажи и касса',
        desc: 'Продажа оформляется за секунды — очередь у кассы не копится. Смены и наличные под контролем.',
      },
      warehouse: {
        title: 'Складской учёт',
        desc: 'Остатки товаров в реальном времени — от цемента до арматуры, в любых единицах.',
      },
      debts: {
        title: 'Долги клиентов',
        desc: 'Каждый долг зафиксирован: кто, сколько и когда обещал вернуть.',
      },
      purchases: {
        title: 'Закуп и поставщики',
        desc: 'Приход товара, поставщики и закупочные цены — в одном журнале.',
      },
      employees: {
        title: 'Сотрудники и права',
        desc: 'Владелец, администратор и продавцы — у каждого свои права и рабочие смены.',
      },
      reports: {
        title: 'Отчёты и аналитика',
        desc: 'Выручка, прибыль и движение товара — готовый отчёт в один клик, без ручных подсчётов.',
      },
    },
    cta: {
      eyebrow: 'Заявка',
      title: 'Оставить заявку',
      subtitle:
        'Продажа — за секунды, отчёт — в один клик. Оставьте имя и телефон, администратор свяжется с вами.',
      nameLabel: 'Имя',
      namePlaceholder: 'Введите имя',
      phoneLabel: 'Телефон',
      phonePlaceholder: '+998 __ ___ __ __',
      submit: 'Оставить заявку',
      success: 'Заявка отправлена — скоро свяжемся',
      privacy: 'Данные используются только для связи с вами',
    },
    footer: {
      privacy: 'Политика конфиденциальности',
      tagline: 'ERP для строительного бизнеса',
    },
  },
  placeholder: {
    soon: 'Раздел в разработке',
  },
  // SuperAdmin консоль (docs/Web design superadmin). Макеты только на русском;
  // ключи заведены на все три языка, uz/en заполняются позже (TZ §A4).
  sa: {
    nav: {
      dashboard: 'Панель',
      requests: 'Заявки',
      stores: 'Магазины',
      billing: 'Подписки и оплаты',
      users: 'Пользователи',
      settings: 'Настройки',
    },
    auth: {
      title: 'Консоль платформы',
      subtitle: 'Вход только для администратора Buildix.',
      notSuperAdmin: 'Эта страница только для администратора платформы.',
    },
    placeholder: {
      title: 'Раздел готовится',
      body: 'Оболочка консоли работает: навигация, тема и доступ. Содержимое этого экрана появится на этапе {{phase}}.',
    },
    dashboard: {
      title: 'Панель Buildix',
      subtitle: 'все магазины платформы',
      kpi: {
        activeStores: 'Активных магазинов',
        newThisMonth: '+{{count}} за этот месяц',
        newRequests: 'Новые заявки',
        fromWelcome: 'с welcome-страницы',
        revenue: 'Доход по подпискам',
        revenueSoon: 'появится вместе с тарифами',
        perMonth: 'сум/мес',
        overdue: 'Просрочили оплату',
        overdueHint: 'напомните об оплате',
      },
      systemsOk: 'Все системы работают',
      systemsDown: 'Нет связи с сервером',
      acceptedHint: 'принята — свяжитесь с клиентом',
      rejectedHint: 'отклонена',
      requestsTitle: 'Заявки на подключение',
      viewAll: 'все заявки',
      noRequests: 'Новых заявок нет',
      attentionTitle: 'Требует внимания',
      allGood: 'Всё в порядке',
      overdueLine: '«{{name}}» — оплата просрочена {{days}} дн.',
      overdueHelp: 'позвоните владельцу или ограничьте доступ',
      expiringLine: 'Подписок истекает на этой неделе: {{count}}',
      storesTitle: 'Магазины',
      byLastActivity: 'последняя активность',
    },
    store: {
      status: { active: 'Активен', overdue: 'Просрочка', blocked: 'Заблокирован' },
      paidUntil: 'до {{date}}',
      noExpiry: 'без срока',
      users: '{{count}} польз.',
      block: 'Блокировать',
      unblock: 'Включить',
      blockedByOperator: 'Заблокировано оператором платформы',
      since: 'с {{date}}',
      ownerTitle: 'Владелец',
      owner: 'Имя',
      phone: 'Телефон',
      subscriptionTitle: 'Подписка',
      plan: 'Тариф',
      planSoon: 'появится в S3',
      paidUntilLabel: 'Оплачен до',
      statsTitle: 'Активность',
      usersLabel: 'Пользователей',
      checksThisMonth: 'Чеков за месяц',
      lastActivity: 'Последняя активность',
      outstandingDebt: 'Долги клиентов',
      paymentsTitle: 'История оплат',
      paymentsSoon: 'Появится вместе с подписками и оплатами.',
      blockedReason: 'Причина блокировки',
      blockWarning: 'Блокировка мгновенно закрывает вход всем пользователям магазина. Данные сохраняются.',
      blockFull: 'Заблокировать магазин',
      unblockFull: 'Включить магазин',
    },
    requests: {
      title: 'Заявки на подключение',
      subtitle: 'заполняются на welcome-странице (имя + телефон)',
      tabs: { new: 'Новые', accepted: 'Принятые', rejected: 'Отклонённые', all: 'Все' },
      col: {
        applicant: 'Заявитель',
        phone: 'Телефон',
        received: 'Поступила',
        status: 'Статус',
      },
      status: {
        new: 'Новая',
        accepted: 'Принята',
        connected: 'Подключена',
        rejected: 'Отклонена',
      },
      searchPlaceholder: 'Имя или телефон…',
      empty: 'Заявок в этой категории нет',
      call: 'Позвонить',
      accept: 'Принять',
      reject: 'Отклонить',
      reopen: 'Вернуть',
      createStore: 'Создать магазин',
      storeCreated: 'магазин создан',
      rejectedByOperator: 'Отклонено оператором',
      workflowHint:
        'Порядок работы: позвоните заявителю → «Принять» → «Создать магазин» — создаётся магазин и аккаунт владельца. Логин и адрес можно отправить по SMS, пароль передайте лично.',
    },
    create: {
      title: 'Создать магазин',
      storeName: 'Название магазина',
      ownerName: 'Имя владельца',
      ownerPhone: 'Телефон',
      standaloneHint: 'Новый магазин без заявки',
      newStore: 'Создать магазин',
      address: 'Адрес магазина',
      addressHint: 'формируется из названия — по этому адресу владелец и его сотрудники входят в систему',
      username: 'Логин владельца',
      password: 'Пароль',
      generate: 'Сгенерировать',
      period: 'Оплачено на',
      months: '{{count}} мес.',
      paidUntil: 'Оплачен до:',
      free: 'свободно',
      taken: 'занято',
      submit: 'Создать магазин',
      passwordWarning:
        'Пароль показывается ОДИН раз и нигде не сохраняется. Скопируйте его сейчас и передайте владельцу лично — по SMS пароль не отправляется.',
      doneTitle: 'Магазин создан',
      doneBody: 'Передайте владельцу адрес и логин. Пароль скопируйте сейчас — после закрытия окна он не восстанавливается, только сброс.',
    },
    stores: {
      title: 'Магазины',
      subtitle: 'все точки платформы, тарифы и статус',
      summary: '{{total}} магазинов · активных: {{active}} · просрочка: {{overdue}} · заблокировано: {{blocked}}',
      filters: { all: 'Все', active: 'Активные', overdue: 'Просрочка', blocked: 'Заблокированные' },
      col: {
        store: 'Магазин',
        owner: 'Владелец',
        plan: 'Тариф',
        paidUntil: 'Оплачен до',
        users: 'Польз.',
        status: 'Статус',
      },
      searchPlaceholder: 'Название, владелец или город…',
      empty: 'Ничего не найдено',
    },
    billing: {
      title: 'Подписки и оплаты',
      subtitle: 'тарифы, оплаты и просрочки',
      summary: 'ожидается в месяц: {{expected}} сум · просрочено: {{overdue}} сум',
      tabs: { all: 'Все', soon: 'Скоро срок', overdue: 'Просрочены' },
      status: { paid: 'Оплачен', soon: 'Скоро срок', overdue: 'Просрочен' },
      plans: { Start: 'Старт', Standard: 'Стандарт', Pro: 'Про' },
      planStores: '{{count}} магазинов',
      planLimits: 'до {{points}} точек · пользователей: {{users}}',
      unlimited: 'без лимита',
      channels: { Cash: 'Наличные', Click: 'Click', Payme: 'Payme', Transfer: 'Перечисление' },
      col: { amount: 'Сумма/мес' },
      lastPayment: 'послед. оплата: {{date}} · {{channel}}',
      noPayments: 'оплат ещё не было',
      searchPlaceholder: 'Магазин…',
      payAction: 'Оплата получена',
      payTitle: 'Оплата получена',
      payConfirm: 'Записать оплату',
      period: 'Период',
      channel: 'Способ оплаты',
      amount: 'К записи',
      note: 'Комментарий',
      notePlaceholder: 'необязательно — номер квитанции и т.п.',
      anchorOnExpiry: 'Продлено от прежней даты — день оплаты не сдвигается.',
      anchorOnToday: 'Отсрочка истекла и доступ был закрыт — считаем с сегодня.',
      anchorManual: 'Срок задан вручную.',
      customMonths: 'или',
      customDate: 'Дата',
      autoDate: 'автоматически',
      remindAll: 'Напомнить всем должникам',
      remindResult: 'доставлено: {{sent}} · без Telegram: {{unreachable}}',
      noTelegram: 'нет Telegram',
      noTelegramHint: 'Владелец не привязал Telegram — напоминание не дойдёт, позвоните ему.',
      recentTitle: 'Последние платежи',
      noPaymentsYet: 'Платежей пока нет',
    },
    users: {
      title: 'Пользователи платформы',
      subtitle: 'все сотрудники во всех магазинах',
      summary: '{{total}} пользователей · владельцев: {{owners}} · админов: {{admins}} · продавцов: {{sellers}} (на странице)',
      roles: { Owner: 'Владелец', Admin: 'Админ', Seller: 'Продавец' },
      col: { user: 'Пользователь', role: 'Роль', store: 'Магазин', lastLogin: 'Последний вход' },
      searchPlaceholder: 'Имя, логин или телефон…',
      allStores: 'Все магазины',
      resetPassword: 'Сменить пароль',
      resetTitle: 'Новый пароль',
      resetConfirm: 'Установить пароль',
      resetWarning: 'Старый пароль перестанет работать сразу, и все сессии пользователя будут закрыты. Передайте новый пароль лично — по SMS он не отправляется.',
      resetDone: 'Пароль изменён',
      resetDoneBody: 'Скопируйте пароль сейчас — после закрытия окна он не восстанавливается, только повторный сброс.',
      scopeHint: 'Суперадмин управляет только доступом к платформе: пароль и блокировка. Роли и права внутри магазина настраивает его владелец или админ.',
    },
    settings: {
      title: 'Настройки платформы',
      subtitle: 'тарифы, оплата, SMS и правила блокировки — для всех магазинов',
      saved: 'Настройки сохранены',
      plansTitle: 'Тарифы',
      plansHint: 'цена в сумах за месяц — применяется со следующего платежа',
      notifyTitle: 'Уведомления магазинам (Telegram)',
      notifyHint: 'отправляются владельцу магазина в Telegram. SMS не используется — сообщения бесплатны, доставка подтверждается, а владелец может там же запросить отчёт.',
      notifyExpiring: 'Скоро конец подписки',
      notifyExpiringSub: 'за {{count}} дн. до окончания',
      expiryReminderDays: 'За сколько дней напоминать',
      notifyBlocked: 'Магазин заблокирован',
      notifyBlockedSub: 'сразу при блокировке — с причиной',
      blockTitle: 'Правила блокировки',
      blockHint: 'что происходит при просрочке оплаты',
      graceDays: 'Дней отсрочки после конца подписки',
      warnOnOverdue: 'Предупреждение в интерфейсе',
      warnOnOverdueSub: 'жёлтая плашка владельцу и админу с 1-го дня просрочки',
      restrictAfterGrace: 'Режим «только просмотр»',
      restrictAfterGraceSub: 'после отсрочки: продажи и приёмка закупа блокируются, данные видны',
      fullBlockAfterDays: 'Полная блокировка входа (дней)',
      fullBlockAfterDaysSub: '0 — не блокировать вход никогда',
      supportTitle: 'Контакты поддержки',
      supportHint: 'показываются на странице входа',
      supportPhone: 'Телефон',
      supportTelegram: 'Telegram',
      supportEmail: 'E-mail',
      applyHint: 'Правила блокировки вступают в силу сразу после сохранения.',
    },
  },
};

export type TranslationSchema = typeof ru;
